import { useTheme } from '@context/ThemeContext'

export default function ThemeToggle({ variant = 'sidebar', showLabel = true }) {
  const { theme, isDarkMode, setTheme, toggleTheme, themes } = useTheme()

  if (variant === 'sidebar' || variant === 'login') {
    const themeOptions = [
      { value: themes.light, label: 'Claro', icon: 'fa-sun' },
      { value: themes.dark, label: 'Escuro', icon: 'fa-moon' },
    ]

    return (
      <div className={`theme-mode-selector theme-mode-selector--${variant}`}>
        {showLabel ? (
          <span className="theme-mode-selector-title">
            <i className="fas fa-circle-half-stroke" aria-hidden="true" />
            Aparência
          </span>
        ) : null}
        <div className="theme-mode-selector-options" role="group" aria-label="Modo de aparência">
          {themeOptions.map((option) => {
            const isSelected = theme === option.value

            return (
              <button
                type="button"
                className={`theme-mode-option ${isSelected ? 'is-selected' : ''}`}
                onClick={() => setTheme(option.value)}
                aria-pressed={isSelected}
                title={`Ativar modo ${option.label.toLowerCase()}`}
                key={option.value}
              >
                <i className={`fas ${option.icon}`} aria-hidden="true" />
                {showLabel ? <span>{option.label}</span> : null}
              </button>
            )
          })}
        </div>
      </div>
    )
  }

  const targetThemeLabel = isDarkMode ? 'claro' : 'escuro'
  const currentThemeLabel = isDarkMode ? 'Escuro' : 'Claro'

  return (
    <button
      type="button"
      className={`theme-toggle theme-toggle--${variant}`}
      onClick={toggleTheme}
      role="switch"
      aria-checked={isDarkMode}
      aria-label="Modo de aparência"
      title={`Alternar para tema ${targetThemeLabel}`}
    >
      <span className="theme-toggle-track" aria-hidden="true">
        <span className="theme-toggle-thumb">
          <i className={`fas ${isDarkMode ? 'fa-moon' : 'fa-sun'}`} />
        </span>
      </span>
      {showLabel ? <span className="theme-toggle-label">{currentThemeLabel}</span> : null}
    </button>
  )
}
